import * as React from 'react';

import * as styles from './ScrollFade.css';
import { easeIn, getMask } from './helpers';

interface IScrollFadeProps {
  size: number;
}

export const ScrollFade: React.FC<IScrollFadeProps> = ({ size }) => {
  const rootRef = React.useRef<HTMLDivElement>(null);

  const onScroll = React.useCallback(() => {
    /* istanbul ignore next */
    const scrollElement = rootRef.current?.parentElement;

    if (scrollElement) {
      const { offsetHeight, scrollHeight, scrollTop } = scrollElement;

      const opacityTop = easeIn((scrollHeight - offsetHeight - scrollTop) / (offsetHeight - scrollHeight), 10);
      const opacityBottom = easeIn(scrollTop / (offsetHeight - scrollHeight), 10);
      const mask = getMask({ size, opacityTop, opacityBottom });

      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }
  }, [size]);

  React.useEffect(() => {
    /* istanbul ignore next */
    const scrollElement = rootRef.current?.parentElement;
    /* istanbul ignore next */
    if (!scrollElement) {
      return;
    }

    const { offsetHeight, scrollHeight } = scrollElement;

    if (offsetHeight !== scrollHeight) {
      const mask = getMask({ size, opacityTop: 1, opacityBottom: 0 });
      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }

    scrollElement.addEventListener('scroll', onScroll, { passive: true });

    return () => scrollElement.removeEventListener('scroll', onScroll);
  }, [onScroll, size]);

  return <span ref={rootRef} className={styles['container']} data-testid="scroll_fade_element" />;
};
